import React from 'react';
import PropTypes from 'prop-types';

export default function PrivateLandIcon({ color = '#ffffff', width = 20, height = 20 }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width={width} height={height} fill={color}>
      <path d="M364.5 337.3c20.1-21.2 33.5-47.8 38.6-76.5s1.7-58.3-9.9-85.1s-30.7-49.6-55.1-65.7s-52.9-24.6-82.1-24.6s-57.7 8.6-82.1 24.6s-43.5 38.9-55.1 65.7s-15 56.4-9.9 85.1s18.5 55.3 38.6 76.5c11.5-18.4 27.5-33.5 46.5-44s40.3-16 62-16c21.7 0 43 5.5 62 16s35 25.6 46.5 44zM178.9 368.7L256 445.8l77.1-77.1c-6.9-14.6-17.8-26.9-31.5-35.6s-29.5-13.2-45.6-13.2s-32 4.6-45.6 13.2s-24.6 21-31.5 35.6zM256 506.2L120.2 370.4c-26.9-26.9-45.1-61.1-52.5-98.3s-3.6-75.8 10.9-110.9s39.1-65.1 70.7-86.2S218 42.7 256 42.7s75.1 11.3 106.7 32.4s56.2 51.1 70.7 86.2s18.3 73.7 10.9 110.9s-25.7 71.5-52.5 98.3L256 506.2zm0-292.9a21.3 21.3 0 1 0 0-42.7 21.3 21.3 0 1 0 0 42.7zm0-85.3a64 64 0 1 1 0 128 64 64 0 1 1 0-128z" />
    </svg>
  );
}

PrivateLandIcon.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};
